import { getMetaKey } from '../selectors';

const saveStatuses = {
  adSaveReady: `Save (${getMetaKey()}+S)`,
  adSaveError: 'Save failed',
  adSaveSuccess: 'Saved!',
  adSavingStill: 'Still saving...',
  adSaving: 'Saving...',
};

export default saveStatuses;



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Builder/config/saveStatuses.js